<template>
    <span v-if="diagnostics" v-tooltip="'Stan kas'" class="mr-2 pr-1 d-flex">
        <button class="cash-button p-0 btn btn-link" @click="goToDiagnostics">
            <a-icon width="20px" height="20px" icon="CashRegister" />

            <a-icon
                v-if="someIsInvalid"
                class="icon-danger text-danger ml-0"
                :class="{ pulse: shouldPulse }"
                icon="WarningFull"
            />
        </button>
    </span>
</template>

<script>
export default {
    data() {
        return {
            shouldPulse: false
        }
    },

    computed: {
        diagnostics() {
            return this.$store.getters.getActiveDiagnostics
        },

        someIsInvalid() {
            return this.$store.getters.someDiagnosticIsInvalid
        }
    },

    methods: {
        goToDiagnostics() {
            if (this.$route.name === 'diagnostics') {
                return
            }
            this.$router.push({ name: 'diagnostics' })
        },

        async setPulseWarning() {
            const storageDiagnostics = await this.$store.$storage.getItem(
                'diagnostics'
            )
            const storeDiagnostics = JSON.stringify(
                this.$store.getters.getDiagnosticStatuses
            )

            if (storeDiagnostics !== storageDiagnostics) {
                this.shouldPulse = true
            } else {
                this.shouldPulse = false
            }
        }
    },

    async created() {
        this.setPulseWarning()
    },

    watch: {
        diagnostics() {
            this.setPulseWarning()
        }
    }
}
</script>

<style lang="scss">
.cash-button {
    position: relative;

    .icon-danger {
        pointer-events: none;
        width: 14px;
        height: 14px;
        top: 60%;
        position: absolute;
        left: 55%;

        &.pulse {
            svg {
                animation: pulse2 1.25s infinite;
            }
        }
    }
}

@keyframes pulse2 {
    0% {
        transform: scale(1);
        opacity: 0.5;
    }

    30% {
        // transform: scale(1.5);
        opacity: 1;
    }

    50% {
        transform: scale(1.5);
        opacity: 1;
    }
    80% {
        // transform: scale(1.5);
        opacity: 1;
    }

    100% {
        transform: scale(1);
        opacity: 0.5;
    }
}
</style>
